import * as yup from 'yup';

const supplyModalSchema = yup.object({
    amount: yup
        .string()
        .required('Amount is required.')
        .test('max-balance', 'Amount is more than balance', function (value) {
            const { maxBalance } = this.options.context || {};
            if (!value || !maxBalance) return true;

            try {
                return Number(value) <= Number(maxBalance);
            } catch {
                return false;
            }
        }),
});

export type SupplyModalData = yup.InferType<typeof supplyModalSchema>;

export default supplyModalSchema;
